import { defineNuxtPlugin, useNuxtApp, useRuntimeConfig } from "#app";
import { useFetchUtils } from "../composables/useFetchUtils.mjs";
export default defineNuxtPlugin(() => {
  const config = useRuntimeConfig();
  const nuxtApp = useNuxtApp();
  const { buildApiRequestHeaders, parseFormData, addApiRequestBreadcrumb, buildApiErrorPayload, logApiError } = useFetchUtils();
  return {
    provide: {
      apiFetch: async (apiPath, options = { method: "GET" }) => {
        const headers = buildApiRequestHeaders(options);
        let method = options.method ? options.method.toUpperCase() : "GET";
        const isGetRequest = method === "GET";
        const params = options.params ? parseFormData(options.params) : void 0;
        const body = options.body ? parseFormData(options.body) : void 0;
        const submitData = params ?? body;
        let payload = void 0;
        if (submitData) {
          if (isGetRequest) {
            payload = submitData;
          } else {
            payload = new FormData();
            if (method === "PUT") {
              method = "POST";
              payload.append("_method", "PUT");
            }
            Object.keys(submitData).forEach((key) => {
              payload.append(key, submitData[key]);
            });
          }
        }
        delete options.body;
        delete options.params;
        return await $fetch(apiPath, {
          baseURL: config.public.apiUrl,
          ...options,
          method,
          [isGetRequest ? "params" : "body"]: payload,
          headers,
          retry: isGetRequest ? 2 : false,
          retryDelay: 100,
          retryStatusCodes: [408, 409, 425, 429, 500, 502, 503, 504],
          // 500 is required to retry on missing internet connection, but would be better to exclude it
          onResponse({ request, response }) {
            addApiRequestBreadcrumb(request, options, response);
          },
          onResponseError({ response, error, request }) {
            addApiRequestBreadcrumb(request, options, response);
            const errorPayload = buildApiErrorPayload(response, error);
            logApiError(errorPayload);
            if (!options.silent && method !== "GET") {
              nuxtApp.$notify("error", errorPayload.message);
            }
            return Promise.reject(errorPayload);
          }
        });
      }
    }
  };
});
